import SecaoSicc from './SecaoSicc';

export { SecaoSicc };

export default SecaoSicc;
